import type { FC, SVGProps } from 'react';
import { ICONS, type IconName } from './icons';

export interface IconProps extends Omit<SVGProps<SVGSVGElement>, 'name'> {
  /** Nombre del ícono, p.ej. 'outline/user' o 'solid/handbag'. */
  name: IconName;
  /** Tamaño (ancho y alto) en px. Default 24. */
  size?: number | string;
}

/**
 * Ícono del Design System. Renderiza el SVG desde el registro `ICONS` en
 * coordenadas 24×24 y toma el color del texto vía `currentColor`, así se pinta
 * con `className="text-*"` o `style={{ color }}` como cualquier texto.
 *
 * Uso: `<Icon name="outline/user" className="text-brand-primary" size={20} />`.
 */
export const Icon: FC<IconProps> = ({ name, size = 24, ...rest }) => {
  const entry = ICONS[name];
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden={rest['aria-label'] ? undefined : true}
      focusable="false"
      {...rest}
    >
      {entry.paths.map((path, i) => (
        <path key={i} {...path} />
      ))}
    </svg>
  );
};

export default Icon;
